import call from "../../service/http";
import { AuthConstants } from "./index";
import AuthService from "./AuthService";
import { EventBus } from "../../utils/eventBus";

export default {
  namespaced: true,
  state: {
    terms: {},
    requirements: [],
    verified: "pending",
    alert: {
      status: "",
      message: "",
    },
    profile: {},
  },
  mutations: {
    SET_TERMS: (state, payload) => {
      state.terms = payload;
    },

    SET_REQUIREMENTS: (state, payload) => {
      state.requirements = payload;
    },

    SET_VERIFY: (state, payload) => {
      state.verified = payload;
    },

    SET_ALERT: (state, payload) => {
      state.alert = payload || {
        status: "",
        message: "",
      };
    },

    SET_PROFILE: (state, payload) => {
      state.profile = payload;
    },
  },
  getters: {
    terms: (state) => state.terms,
    requirements: (state) => state.requirements,
    error: (state) => state.error,
    verified: (state) => state.verified,
    alert: (state) => state.alert,
    profile: (state) => state.profile,
  },
  actions: {
    getTerms: ({ commit }) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("get", AuthConstants.terms)
        .then((res) => {
          commit("SET_TERMS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    getMembershipRequirements: ({ commit }) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("get", AuthConstants.requirements)
        .then((res) => {
          commit("SET_REQUIREMENTS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    register: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.register, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("route-change", {
            name: "Otp",
            params: { id: btoa(JSON.stringify(res.data.data)) },
          });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    login: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.login, data)
        .then((res) => {
          AuthService.login(res.data.data.token, res.data.data.user);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    refreshSessionUser({ commit }, data) {
      call("get", `${AuthConstants.sessionUser}/${data.id}`)
        .then((res) => {
          AuthService.setUser(res.data.data, true);
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: error.response.data.message,
            },
            { root: true }
          );
        });
    },

    requestActivation: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.requestActivation, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "success",
              message: res.data.message,
            },
            { root: true }
          );
          EventBus.$emit("activation-success", res.data.data);
        })
        .catch((error) => {
          console.error(error);
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                error?.response?.data?.message ??
                error.response?.message ??
                error.message ??
                "Error Activating your account. contact EBK team",
            },
            { root: true }
          );
        });
    },

    activate: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.activate, data)
        .then((res) => {
          AuthService.login(res.data.data.token, res.data.data.user);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          console.log(err);
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    verify: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.verify, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          AuthService.login(res.data.data.token, res.data.data.user);
        })
        .catch((err) => {
          commit("SET_VERIFY", "failed");
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    verifyOtp: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.verifyOtp, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          AuthService.login(res.data.data.token, res.data.data.user);
        })
        .catch((err) => {
          commit("SET_VERIFY", "failed");
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    sendOtp: ({ commit }, id) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("get", AuthConstants.sendOtp(id))
        .then(() => {
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit("SET_VERIFY", "failed");
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    forgotPassword: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.passwordReset, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "success",
            message: res.data.data,
          });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    resetPassword: ({ commit }, data) => {
      commit("SET_ALERT", null, { root: true });
      commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.password, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "success",
              message: res.data.data,
            },
            { root: true }
          );
          Event.$emit("route-change", { name: "login", params: {} });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },

    user: ({ commit }, silent = false) => {
      commit("SET_ALERT", null, { root: true });
      // commit("SET_LOADING", true, { root: true });
      call("get", AuthConstants.user).then((res) => {
        AuthService.setUser(res.data.data, silent);
        commit("SET_LOADING", false, { root: true });
      });
    },

    logout: () => {
      call("post", AuthConstants.logout).then(() => {
        AuthService.logout();
      });
    },

    searchMember: (context, term) => {
      context.commit("SET_LOADING", true, { root: true });
      call("get", AuthConstants.searchMember(term))
        .then((res) => {
          context.commit("SET_PROFILE", res.data.data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },
    createFirm: (context, payload) => {
      context.commit("SET_LOADING", true, { root: true });
      call("post", AuthConstants.firm, payload)
        .then((res) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("route-change", {
            name: "Otp",
            params: { id: btoa(JSON.stringify(res.data.data)) },
          });
        })
        .catch((err) => {
          context.commit("SET_LOADING", false, { root: true });
          context.commit(
            "SET_ALERT",
            {
              status: "error",
              message: err.response.data.message,
            },
            { root: true }
          );
        });
    },
  },
};
